import useAct from 'Workflows/hooks/useAct'
import useEntryRules from 'Workflows/hooks/useEntryRules'
import Button from 'Shared/components/Button'
import { Rules } from 'SearchBuilder/components/Description/Rules'

export default function EntrySidebar() {
  const act = useAct()
  const { hasRules, description } = useEntryRules()

  function editRules() {
    act.local.editEntryRules()
  }

  return (
    <div className='box workflow-sidebar'>
      <h3 className='no-margin-top'>Entry</h3>
      <p className='dark-grey'>
        Members enter the workflow when they match these rules.
      </p>

      {hasRules ? (
        <Rules description={description} />
      ) : (
        <p className='dark-grey italic'>No entry rules set yet.</p>
      )}

      <div className='margin-top'>
        <Button secondary small onClick={editRules}>
          {hasRules ? 'Edit Entry Rules' : 'Set Entry Rules'}
        </Button>
      </div>
    </div>
  )
}
